(() => {
  const CONFIG = {
    inputName: "attributes[Delivery Date]",
    storageKey: "gs_date_ttl",
    ttlMinutes: 1,
    maxRetries: 10,
    retryInterval: 500,
  };

  const attributeMatch = CONFIG.inputName.match(/^attributes\[(.+)\]$/);
  const attributeKey = attributeMatch ? attributeMatch[1] : null;
  const attachedInputs = new WeakSet();

  const getCookie = (key) => {
    const cookies = document.cookie.split("; ");

    for (const cookie of cookies) {
      const separatorIndex = cookie.indexOf("=");
      const cookieKey = cookie.substring(0, separatorIndex);
      const cookieValue = cookie.substring(separatorIndex + 1);

      if (cookieKey === key) {
        return cookieValue;
      }
    }

    return null;
  };

  const setCookie = (key, value, minutes) => {
    const expiry = new Date();
    expiry.setTime(expiry.getTime() + minutes * 60 * 1000);

    document.cookie =
      `${key}=${value}; expires=${expiry.toUTCString()}; path=/; SameSite=Lax`;
  };

  const getDateInput = () =>
    document.querySelector(`input[name="${CONFIG.inputName}"]`);

  const clearSavedDate = async (input) => {
    if (!attributeKey) {
      console.error("Could not determine the Shopify cart attribute name.");
      return;
    }

    try {
      const root = window.Shopify?.routes?.root || "/";

      const response = await fetch(`${root}cart/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          attributes: {
            [attributeKey]: "",
          },
        }),
      });

      if (!response.ok) {
        throw new Error(`Cart update failed with status ${response.status}`);
      }

      await response.json();

      input.value = "";

      // Clear the visible calendar field when Flatpickr is being used.
      if (input._flatpickr) {
        input._flatpickr.clear();
      }

      input.dispatchEvent(
        new Event("input", {
          bubbles: true,
        })
      );

      console.log(
        `Giftship delivery date cleared from the field and Shopify cart attribute "${attributeKey}".`
      );
    } catch (error) {
      console.error("Unable to clear the Giftship delivery date:", error);
    }
  };

  const handleDateChange = (event) => {
    // Do not create a new cookie when the script itself clears the field.
    if (!event.currentTarget.value) {
      return;
    }

    setCookie(CONFIG.storageKey, "true", CONFIG.ttlMinutes);
    console.log("Delivery date selected. TTL cookie created.");
  };

  const initialize = (retries = CONFIG.maxRetries) => {
    const input = getDateInput();

    if (!input) {
      if (retries > 0) {
        setTimeout(
          () => initialize(retries - 1),
          CONFIG.retryInterval
        );
      } else {
        console.warn("Giftship delivery date input was not found.");
      }

      return;
    }

    if (!attachedInputs.has(input)) {
      input.addEventListener("change", handleDateChange);
      attachedInputs.add(input);
      console.log("Giftship TTL listener attached.");
    }

    if (!getCookie(CONFIG.storageKey) && input.value) {
      console.log("TTL cookie missing or expired. Clearing saved date.");
      clearSavedDate(input);
    }
  };

  document.addEventListener("giftship.loaded", () => initialize());
  document.addEventListener("giftship.drawer-cart.opened", () => initialize());

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initialize());
  } else {
    initialize();
  }
})();